import React, {Component, ReactNode} from 'react'
import { Box, DialogContent, Typography } from '@mui/material';
import {RowFlexContainer} from '../../../../../styledComponents/FlexComponents'
import {NotifyDialogTitle} from '../../../../../components/assocDirector/AssocDirectorCommon'
import {StyledPre} from '../../../../../styledComponents/adminPage/StyledPre'
import {DialogCloseButton} from '../../../../../components/reservations/components/CommonStyle'
import {Close} from '@mui/icons-material'
import EventEmitterExAdmin from '../../../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {
    ApplyDialogActions,
    ApplyPrimaryButton,
    FormLabelContainer,
    OutlinedTextArea,
    SpApplyDialogTitle,
    SpApplyDialogTitleFont,
    StyledApplyFormLabel,
    StyledHeader,
    StyledHeadingHr,
    StyledPageFooterArea,
} from './NatAdminApplicationCommon'
import {PageFotterAreaRight} from '../../../../../components/shared/hoc/withAdminPageTemplate'
import {AdminDialog} from '../../../../../components/shared/pageBaseComponents/AdminDialog'
import {AppAdminContext} from '../../../../../app/AppAdminContext'
import {OptionalChip} from '../../../../../styledComponents/adminPage/Table'

interface Props {
    open: boolean
    commentFormRequired?: boolean
    onChange?: (value: string) => void
    onReception: () => Promise<void>
    onCancel: () => void
    eventEmitter: EventEmitterExAdmin
}

interface State {
    comment: string
}

export default class NatAdminApplicationReceptionDialog extends Component<Props, State> {
    declare context: React.ContextType<typeof AppAdminContext>
    constructor(props: Readonly<Props>) {
        super(props)
        this.state = {
            comment: '',
        }

        this.handleMemoChange = this.handleMemoChange.bind(this)
    }

    componentDidUpdate(prevProps: Props): void {
        if (prevProps.open !== this.props.open) {
            this.setState({
                comment: '',
            })
        }
    }

    handleMemoChange(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({comment: event.target.value}, () => {
            if (this.props.onChange) {
                this.props.onChange(this.state.comment)
            }
        })
    }

    renderDialogContent(): ReactNode {
        const {commentFormRequired} = this.props
        const {comment} = this.state

        return <>
            <Box mb={'16px'}>
                <StyledPre>
                    {'この申請を受け付けます。'}
                    {commentFormRequired && '\n理事長への連絡事項は必要な場合のみご入力ください。'}
                    {'\n受付操作の取り消しはできません。申請内容に見落としがないか十分にご確認ください。'}
                </StyledPre>
            </Box>
            {commentFormRequired &&
                <>
                    <FormLabelContainer>
                        <StyledApplyFormLabel>
                            理事長への連絡事項
                        </StyledApplyFormLabel>
                        <Box ml={'8px'}><OptionalChip label={'任意'}/></Box>
                    </FormLabelContainer>
                    <OutlinedTextArea
                        InputProps={{
                            inputProps: {
                                maxLength: 200,
                                minRows: 6,
                            },
                        }}
                        fullWidth
                        multiline
                        value={comment}
                        placeholder={'200文字以内'}
                        eventKeys={['comment']}
                        eventEmitter={this.props.eventEmitter}
                        onChange={this.handleMemoChange}
                    />
                    <Box mt={'8px'} fontSize={'12px'}>
                        <StyledPre>{'・管理画面でのみ参照可能で、申請者には開示されません。' +
                            '\n・申請受付後は理事長への連絡事項を編集・削除することができません。ご注意ください。'}</StyledPre>
                    </Box>
                </>
            }
        </>
    }

    renderPc(): ReactNode {
        const {onReception, onCancel} = this.props

        return (<>
            <Box width={'750px'}>
                <NotifyDialogTitle>
                    <StyledHeader>
                        <RowFlexContainer>
                            <Typography variant="h5" display={'inline'}>
                                申請の受付
                            </Typography>
                            <DialogCloseButton onClick={onCancel} id={'close'}>
                                <Close/>
                            </DialogCloseButton>
                        </RowFlexContainer>
                    </StyledHeader>
                    <StyledHeadingHr/>
                </NotifyDialogTitle>
                <DialogContent>{this.renderDialogContent()}</DialogContent>
                <ApplyDialogActions>
                    <StyledPageFooterArea>
                        <PageFotterAreaRight>
                            <ApplyPrimaryButton onClick={onReception}>
                                この申請を受け付ける
                            </ApplyPrimaryButton>
                        </PageFotterAreaRight>
                    </StyledPageFooterArea>
                </ApplyDialogActions>
            </Box>
        </>)
    }

    renderSp(): ReactNode {
        const {onReception, onCancel} = this.props

        return <>
            <SpApplyDialogTitle>
                <RowFlexContainer>
                    <SpApplyDialogTitleFont>
                        申請の受付
                    </SpApplyDialogTitleFont>
                    <DialogCloseButton onClick={onCancel}>
                        <Close fontSize={'large'}/>
                    </DialogCloseButton>
                </RowFlexContainer>
            </SpApplyDialogTitle>
            <DialogContent>{this.renderDialogContent()}</DialogContent>
            <ApplyDialogActions>
                <ApplyPrimaryButton
                    onClick={onReception}
                    width={'100%'}
                >
                    この申請を受け付ける
                </ApplyPrimaryButton>
            </ApplyDialogActions>
        </>
    }

    render(): ReactNode {
        const spMode = this.context.showSpModePage

        return (
            <AdminDialog maxWidth={'md'} open={this.props.open}>
                {spMode ? this.renderSp() : this.renderPc()}
            </AdminDialog>
        )
    }
}

NatAdminApplicationReceptionDialog.contextType = AppAdminContext
